import { connect } from 'react-redux'

import {
  doOpenForwardPageExpanded,
  doOpenNotePage,
  doOpenTicketPage,
} from 'actions/pages'
import ListenToKeyboard from 'components/ListenToKeyboard'
import editor from 'shared/editor/utils'

// eslint-disable-next-line no-unused-vars
const select = state => ({
  disableForInput: true,
  preventDefault: true,
})

const perform = (dispatch, ownProps) => ({
  onR: () => {
    dispatch(doOpenTicketPage(ownProps.ticketId, { viaKeyboard: true }))
    setTimeout(editor.focus, 250)
  },
  onN: () => dispatch(doOpenNotePage(ownProps.ticketId)),
  onF: () => dispatch(doOpenForwardPageExpanded(ownProps.ticketId)),
})
export default connect(select, perform)(ListenToKeyboard)
